import React from "react";

export default function useStateReducer(initialState: any) {
  return React.useReducer((state: any, newState: any) => {
    return { ...state, ...newState };
  }, initialState);
}
